import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import './Button.css';

export default function Button({
  as,
  href,
  target,
  rel,
  onClick,
  children,
  leading,
  trailing,
  square = false,
  hoverBounce = false,
  variant = 'default',
  className = '',
  ariaLabel,
  title,
  ...rest
}) {
  const Component = as || (href ? 'a' : 'button');
  const classes = `ui-button ${square ? 'ui-button--square' : ''} ${className}`.trim();
  const finalClass = variant === 'visit' ? `${classes} visit-variant`.trim() : classes;
  const scaleControls = useAnimation();
  const trailingIconControls = useAnimation();

  const handleMouseEnter = () => {
    if (hoverBounce) {
      scaleControls.stop();
      scaleControls.set({ scale: 1 });
      scaleControls
        .start({ scale: 0, transition: { type: 'tween', ease: 'easeOut', duration: 0.08 } })
        .then(() => scaleControls.start({ scale: 1, transition: { type: 'spring', stiffness: 300, damping: 18, mass: 0.6 } }));
    }
    if (variant === 'visit') {
      trailingIconControls.stop();
      trailingIconControls.set({ x: -12, y: 12, opacity: 0 });
      trailingIconControls.start({ x: 0, y: 0, opacity: 1, transition: { type: 'spring', stiffness: 300, damping: 18, mass: 0.6 } });
    }
  };
  const handleMouseLeave = () => {
    if (hoverBounce) {
      scaleControls.stop();
      scaleControls.set({ scale: 1 });
    }
    if (variant === 'visit') {
      trailingIconControls.stop();
      trailingIconControls.set({ x: 0, y: 0, opacity: 1 });
    }
  };

  const sharedProps = {
    className: finalClass,
    onClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    href,
    target,
    rel,
    'aria-label': ariaLabel,
    title,
    ...rest
  };

  if (variant === 'default' && hoverBounce) {
    return (
      <Component {...sharedProps}>
        <motion.span className="ui-button-inner" animate={scaleControls}>
          {leading && <span className="ui-button-leading">{leading}</span>}
          {children && <span className="ui-button-label">{children}</span>}
          {trailing && <span className="ui-button-trailing">{trailing}</span>}
        </motion.span>
      </Component>
    );
  }

  return (
    <Component {...sharedProps}>
      {leading && <span className="ui-button-leading">{leading}</span>}
      {children && <span className="ui-button-label">{children}</span>}
      {trailing && (
        variant === 'visit'
          ? <motion.span className="ui-button-trailing" animate={trailingIconControls}>{trailing}</motion.span>
          : <span className="ui-button-trailing">{trailing}</span>
      )}
    </Component>
  );
}


